/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UpdateSupervisionTask
 */
export interface UpdateSupervisionTask {
    /**
     *
     * @type {string}
     * @memberof UpdateSupervisionTask
     */
    supervisionUrl?: string;
}

/**
 * Check if a given object implements the UpdateSupervisionTask interface.
 */
export function instanceOfUpdateSupervisionTask(
    value: object,
): value is UpdateSupervisionTask {
    return true;
}

export function UpdateSupervisionTaskFromJSON(
    json: any,
): UpdateSupervisionTask {
    return UpdateSupervisionTaskFromJSONTyped(json, false);
}

export function UpdateSupervisionTaskFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): UpdateSupervisionTask {
    if (json == null) {
        return json;
    }
    return {
        supervisionUrl:
            json["supervisionUrl"] == null ? undefined : json["supervisionUrl"],
    };
}

export function UpdateSupervisionTaskToJSON(
    value?: UpdateSupervisionTask | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        supervisionUrl: value["supervisionUrl"],
    };
}
